import script from "./TiposMembresiaList.vue?vue&type=script&setup=true&lang=js"
export * from "./TiposMembresiaList.vue?vue&type=script&setup=true&lang=js"

import "./TiposMembresiaList.vue?vue&type=style&index=0&id=706931a4&scoped=true&lang=css"
import "./TiposMembresiaList.vue?vue&type=style&index=1&id=706931a4&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-706931a4"]])

export default __exports__